import { APIService } from "@/services/APIService/APIService";
import { useService } from "@/services/ServiceContext";
import { ServiceKey } from "@journeyteam/dependency-injection";
import useSwr from "swr/immutable";
export function usePortalConfig() {
	const apiSvc = useService(APIService.serviceKey);
	const portalConfig = useSwr("portal-config", () => {
		return apiSvc.portalConfig.getPortalConfig();
	});

	return portalConfig;
}
